import Api from './Api';

const END_POINT = "products";

export default {
  async get_all(filters = null) {
    let request = {
      params: filters,
    };
    return await Api.get(`${END_POINT}`, request);
  },
  async store(product) {
    return await Api.post(`${END_POINT}`, product);
  },
  async show(product) {
    return await Api.get(`${END_POINT}/${product.id}`);
  },
  async update(product) {
    return await Api.patch(`${END_POINT}/${product.id}`, product);
  },
  async change_status(product) {
    return await Api.patch(`${END_POINT}/${product.id}/change-status`, product);
  },
  async delete(product) {
    return await Api.delete(`${END_POINT}/${product.id}`, product);
  },
  get_prices(product) {
    return Api.get(`${END_POINT}/${product.product_id}/prices`);
  },
  download(filters = null) {
    let request = {
      params: filters,
    };
    return Api.get(`${END_POINT}/donwload`, request);
  },
  async uploadReactive(product) {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return Api.post(`${END_POINT}/uploadReactivos`, product, config);
  },
  async uploadMaterial(product) {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    return Api.post(`${END_POINT}/uploadMaterial`, product, config);
  },
};
